var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/edit pen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.88727 1.11284C8.95946 1.18524 9 1.28332 9 1.38556C9 1.4878 8.95946 1.58588 8.88727 1.65828L8.08135 2.46487L6.53597 0.919688L7.34189 0.113102C7.41434 0.0406829 7.51259 0 7.61503 0C7.71748 0 7.81573 0.0406829 7.88818 0.113102L8.88727 1.11206V1.11284ZM7.53506 3.01032L5.98968 1.46514L0.725337 6.72957C0.68281 6.77209 0.650795 6.82394 0.631841 6.881L0.00982538 8.74604C-0.0014553 8.78004 -0.00305698 8.81651 0.00519952 8.85136C0.013456 8.88622 0.0312455 8.9181 0.0565792 8.94343C0.0819129 8.96876 0.113793 8.98655 0.148656 8.9948C0.183519 9.00306 0.219991 9.00145 0.253996 8.99018L2.11927 8.36824C2.17627 8.34951 2.22812 8.31777 2.27072 8.27553L7.53506 3.01109V3.01032Z",
    fill: "#3B3B3B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-pen.277c61a26d985b5c7f373b5500c9e3c8.svg";